'use strict';

(function ($) {
    const ready = () => {
        const $slider = $("#slider .inner ul");
//        const $li = $slider.find("li");
        $.fn.over_fade = function (interval, duration) {
            const $this = $(this);
            const $children = $this.children();
            let current = 0;
            let next = 1;
            if ($children.length <= 1) {
                return false;
            }
            $children.eq(current).stop().show().css("z-index", 1);
            $children.not(":eq(" + current + ")").hide().css("z-index", 9);

            var fade_loop = function () {
                //現在表示されているもの 以外 を非表示
                $children.not(":eq(" + current + ")").hide();
                //次に表示するもの以外を下に
                $children.not(":eq(" + next + ")").css("z-index", 1);
                //次に表示するものを上にして非表示
                $children.eq(next).css("z-index", 9).hide();
                //次に表示するものをフェードイン
                $children.eq(next).fadeIn(duration);
                //次の番号を取得
                current++;
                if (current >= $children.length) {
                    current = 0;
                }
                next = current + 1;
                if (next >= $children.length) {
                    next = 0;
                }
                sld_timer = setTimeout(fade_loop, interval + duration);
            };
            var sld_timer = setTimeout(fade_loop, interval);
        };
        $slider.over_fade(1000, 5000);

        const close_menu = function () {
            var $this = $(".menu-btn");
            var $menu = $("#global-menu .menu");
            if ($menu.is(":visible")) {
                $menu.stop().slideUp();
                $this.addClass("close");
                $this.removeClass("open");
            } else {
                $menu.stop().slideDown();
                $this.addClass("open");
                $this.removeClass("close");
            }
        };
        $(".menu-btn").on("click", function () {
            close_menu();
            return false;
        });
        $(".menu .btn-close").on("click", function () {
            close_menu();
            return false;
        });

        const $header = $("header");
        $('a[href^="#"]').on("click", function () {
            var speed = 500;
            var href = $(this).attr("href");
            var target = $(href == "#" || href == "" ? 'html' : href);
            if(!target.length){
                return;
            }
            var position = target.offset().top - $header.height();
            $("html, body").animate({scrollTop: position}, speed, "swing");
            return false;
        });

        $('.effect').hide();
        $(window).scroll(function () {
            $(".effect").each(function () {
                var $this = $(this);
                var imgPos = $this.data("effect");
                var scroll = $(window).scrollTop();
                var windowHeight = $(window).height();
                if (scroll > parseInt(imgPos)) {
                    $this.fadeIn();
                } else {
                    $this.fadeOut();
                }
            });
        });

        var targetImgs = $('.hover');
        targetImgs.each(function () {
            var $main = $(this);
            var parent = $main.parent("a");
//            console.log(parent.length);
            if (parent.length) {
                var event = parent;
            } else {
                var event = $main;
            }
            var src = $main.attr("src");
            event.on('mouseenter', function () {
                $main.attr('src', src.replace(new RegExp('(\.gif|\.jpg|\.png)$'), "\-hover" + '$1'));
            }).on('mouseleave', function () {
                $main.attr('src', src.replace(new RegExp('(\-hover)$'), "" + ''));
            });
        });

        /**
         * 販売物件
         */
        (function(){
            var $seach_d = $("#search_d");
            // const $header = $("header");

            if(!$seach_d.length){
                return;
            }
            var $link = $seach_d.find(".term a");
            // console.log($link);
            // console.log(location.hash);

            var current_hash = location.hash ? location.hash : "";
          
            /**
             * カテゴリボタン
            */
            $link.on("click",function(){
                var $this = $(this);
                var href = $this.attr("href");
                // console.log($this);
                if(current_hash == href){
                    current_hash = "";
                }else{
                    current_hash = href;
                }

                $(document).trigger("change_hash");

                // var position = $seach_d.offset().top - $header.height();
                // $("html, body").animate({scrollTop: position}, 500, "swing");

                return false;
            });

            /**
             * hash 変更
            */
            $(document).on("change_hash",function(){
                // location.hash = current_hash;

                var $nav_link = $("nav .term a").removeClass("active");
                var slug = "";
                if(current_hash){
                    $nav_link
                        .filter('[href="'+current_hash+'"]')
                        .addClass("active");

                    history.pushState(null, null, current_hash)

                    slug = current_hash.substr(1);

                }else{
                    var hashString = location.hash.substr(1); // remove '#'
                    history.replaceState('', document.title, window.location.pathname);
                }

                if(slug){
                    $(".sales .sale")
                    .hide()
                    .filter('[data-terms*="'+slug+'"]')
                    .show()
                    ;
                }else{
                    $(".sales .sale").show();
                }

                console.log(current_hash);
            });

            $(document).trigger("change_hash");

        })();
    };
    $(document).ready(ready);
})(jQuery);
